import mixpanel from "mixpanel-browser";

const inProd = process.env.NODE_ENV === "production";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string, {
  debug: !inProd,
  ignore_dnt: !inProd,
});

export const Mixpanel = {
  instance: mixpanel,
  identify(id: string) {
    try {
      if (inProd) mixpanel.identify(id);
    } catch (error: any) {
      console.log("Mixpanel error:", error);
    }
  },
  track(name: string, props: any) {
    try {
      if (inProd) mixpanel.track(name, props);
    } catch (error: any) {
      console.log("Mixpanel error:", error);
    }
  },
  getDistinctId() {
    try {
      if (inProd) return mixpanel.get_distinct_id();
    } catch (error: any) {
      console.log("Mixpanel error:", error);
    }
  },
};
